<template>
  <a-card :title="'付费统计' + today_dt">
    <a-space >
    </a-space>
      <table class="stats-table">
        <legend>付费率统计 <a-spin v-if="loading" /></legend>
       <tr>
          <th >项目</th><th>数据</th><th>公式</th><th>说明</th>
        </tr>
        <tr v-for="(item, index) in stats_data.payment_user_stats" :key="index">
          <td>{{index}} 日内用户付费率</td>
          <td> {{ (item["payment_count"] / item["count"] * 100).toFixed(2) }}% </td>
          <td> {{ item["payment_count"] }} / {{ item["count"] }}  </td>
          <td>{{ index }} 日前注册用户在 {{ index }} 日内某一天付费 </td>
        </tr>
       <tr>
          <td>30日内付费用户数</td><td> {{ stats_data.pay_user_30day_count }} </td><td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员。</td>
        </tr> 

        <tr>
          <td >30日续费数量</td><td>{{ stats_data.renew_order_count }}</td><td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员。</td>
        </tr>
        <tr>
          <td >30日会员已过期数量</td><td>{{ stats_data.vip_expire_count }}</td><td></td>
          <td> 包括应用内购买会员、后台开通会员、终身会员等所有会员</td>
        </tr>
       <tr>
          <td >30日续费率</td><td>
            {{ (stats_data.renew_order_count / (stats_data.vip_expire_count + stats_data.renew_order_count) * 100).toFixed(2)  }}%
          </td><td></td>
          <td> 30日续费数量 / (30日续费数量 + 30日会员已过期数量)</td>
        </tr>
        <tr>
          <td >7日内 周卡续费率 （计算前7日~14日开通用户）</td><td>
            {{ (stats_data.renew_7_days.valid_count / (stats_data.renew_7_days.total) * 100).toFixed(2)  }}%
          </td><td></td>
          <td> 至今有效 {{  stats_data.renew_7_days.valid_count }}<br>
            7日前有效 {{stats_data.renew_7_days.total}}</td>
        </tr> 
        <tr>
          <td >30日内 月卡续费率 （计算前30日~60日开通用户）</td><td>
            {{ (stats_data.renew_30_days.valid_count / (stats_data.renew_30_days.total) * 100).toFixed(2)  }}%
          </td><td></td>
          <td> 至今有效 {{ stats_data.renew_30_days.valid_count }}<br>
            30日前有效 {{stats_data.renew_30_days.total}}</td>
        </tr>
      </table>
      
  </a-card>


</template>
<script>
import { defineComponent} from 'vue'
import request from '@/utils/request'
import store from '@/store'


export default defineComponent({
  components: {
    // UserEditor,
    // SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      stats_data:{
        "payment_user_stats":{} ,
        "life_user": {
          "count":0,
          "new_generate_count": 0,
        },
        "new_order_sum": {
          "alipay": {},
          "apple": {},
        },
        "download_counts": {},
        "generate_counts": {},
        "new_user_generate_counts": {},
        "new_user_30d_count": {
          ios: 0,
          android: 0
        },
        "new_user_7d_count": {
          ios: 0,
          android: 0
        },
        "new_user_payment_30d_count": {
          ios: 0,
          android: 0
        },
        "new_user_payment_7d_count": {
          ios: 0,
          android: 0
        },
        "new_user_count": {
          ios: 0,
          android: 0
        },
        "new_user_vip_count": {
          ios: 0,
          android: 0
        },
        "new_vip_count": {
          ios: 0,
          android: 0
        },
        "new_user_payment_amount": {
          ios: 0,
          android: 0
        },
        "user_totals": {
          ios:{}, android:{}
        },
        "payment_sums": {
          ios:{}, android:{}
        },
        "vip_expire_count": 0,
        "renew_order_count": 0,
        "payment_user_totals": {
          ios:{}, android:{}
        },
        "pay_today_amount": {
            "pay_amount": 0,
            "total_amount": 0,
            "discount_amount": 0
        },
        "pay_total_amount": {
            "pay_amount": 0,
            "total_amount": 0,
            "discount_amount": 0
        },
        "pay_user_7day_amount": {
            "pay_amount": 0,
            "total_amount": 0,
            "discount_amount": 0
        },
        "pay_user_7day_count": 0,
        "pay_user_30day_count": 0,
        "pay_user_today_amount": {
            "pay_amount": 0,
            "total_amount": 0,
            "discount_amount": 0
        },
        "pay_user_today_count": 0,
        "pay_user_total_count": 0,
        "user_7day_count": 0,
        "user_30day_count": 0,
        "user_today_count": 0,
        "user_total_count": 0,
        "vip_today_count": 0,
        "vip_total_count": 0,
        "renew_7_days": {valid_count:0, total:0},
        "renew_30_days": {valid_count:0, total:0},
      },
       formSearch: {
        user_id: '',
        nickname: '',
        mobile: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.load()
  },
  computed:{
    username : () => {
      if (store) {
        return `${store.state.user.nickname}-${store.state.user.user_id}`
      }
      
    },
  },
  methods: {
    async load () {
      this.loading = true
      // const rsp = await request.get('/api/stats/total', {})
      // this.loading = false
      // for(let k in rsp.data) {
      //   this.stats_data[k] = rsp.data[k]
      // }
      const repPayment = await request.get('/api/stats/payment', {})
      for(let k in repPayment.data) {
        this.stats_data[k] = repPayment.data[k]
      }
      const statsRenew = await request.get('/api/stats/renew', {})
      this.loading = false
      for(let k in statsRenew.data) {
        this.stats_data[k] = statsRenew.data[k]
      }
    },
  
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.stats-table {
  
}
.stats-table td {
  border: 1px solid #BBB;
  padding: 4px 8px;
}
</style>